/** Line icons for the five lever cards — same style as `capacity/icons.tsx`'s `SC_ICON`. */

import type { ReactElement } from "react";

import type { Scenario5LeverId } from "@/lib/data";

export const LEVER_ICON: Record<Scenario5LeverId, ReactElement> = {
  relo: (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M3 12h12M11 8l4 4-4 4" />
      <path d="M20 4v16" />
    </svg>
  ),
  pack: (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect x="3" y="10" width="8" height="8" rx="1" />
      <rect x="13.5" y="4" width="7" height="7" rx="1" />
      <rect x="13.5" y="13" width="7" height="7" rx="1" />
    </svg>
  ),
  conv: (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M4 8h13l-3-3M20 16H7l3 3" />
    </svg>
  ),
  cap: (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M4 9V4h5M20 9V4h-5M4 15v5h5M20 15v5h-5" />
    </svg>
  ),
  pace: (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="12" cy="12" r="9" />
      <path d="M12 7v5l3 2" />
    </svg>
  ),
};
